"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _components = require("components");

var _topups = require("redux/modules/topups");

var _payments = require("redux/modules/payments");

var _customer = require("redux/modules/customer");

var _CheckoutLayout = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/CheckoutLayout");

var _CheckoutLayout2 = _interopRequireDefault(_CheckoutLayout);

var _CheckoutPriceBox = require("@quixeltools/quixel-ui-library/dist/components/megascans/checkout/CheckoutPriceBox");

var _CheckoutPriceBox2 = _interopRequireDefault(_CheckoutPriceBox);

var _CheckoutStickyHeader = require("@quixeltools/quixel-ui-library/dist/components/megascans/checkout/CheckoutStickyHeader");

var _CheckoutStickyHeader2 = _interopRequireDefault(_CheckoutStickyHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuyPoints = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _customer.getCustomer)());
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    price: state.payments.price,
    currentPayment: state.payments.currentPayment
  };
}, { buyTopup: _topups.buyTopup, getPrice: _payments.getPrice }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(BuyPoints, _React$Component);

  function BuyPoints(props) {
    (0, _classCallCheck3.default)(this, BuyPoints);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BuyPoints.__proto__ || (0, _getPrototypeOf2.default)(BuyPoints)).call(this, props));

    _this.state = {};
    _this.getCurrentTopUp = _this.getCurrentTopUp.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(BuyPoints, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var flag = true,
          elem = document.getElementById("checkout-price");
      window.onscroll = function () {
        elem = document.getElementById("checkout-price");

        var scrollTo = elem.parentNode.clientHeight - elem.clientHeight + 77;
        elem.style.width = "22.3%";
        elem.style.maxWidth = "320px";
        if (window.scrollY + 60 > scrollTo) {
          elem.style.position = "absolute";
          if (flag === true) {
            elem.style.top = scrollTo + "px";
            flag = false;
          }
        } else if (window.scrollY + 60 <= scrollTo) {
          if (elem.getBoundingClientRect().top + 35 - window.scrollY < 0) {
            elem.style.width = "22.3%";
            elem.style.top = "60px";
            elem.style.position = "fixed";
            flag = true;
          } else {
            elem.style.width = "unset";
            elem.style.top = "unset";
            elem.style.position = "unset";
          }
        }
      };
    }
  }, {
    key: "getCurrentTopUp",
    value: function getCurrentTopUp() {
      var _props = this.props,
          user = _props.user,
          id = _props.params.id;

      var pointsMap = user && user.subscription && user.subscription.refillPricePointMap ? user.subscription.refillPricePointMap : [];

      return _ramda2.default.find(_ramda2.default.propEq("id", id))(pointsMap);
    }
  }, {
    key: "renderPaymentWizard",
    value: function renderPaymentWizard() {
      var topUp = this.getCurrentTopUp();
      var user = this.props.user;

      var planId = user && user.subscription && user.subscription.planId ? user.subscription.planId : null;

      if (planId && topUp) {
        return _react2.default.createElement(
          "div",
          { style: { marginTop: "3em" } },
          _react2.default.createElement(_components.PaymentWizard, {
            amount: topUp.price,
            currency: "USD",
            transactionType: "refill-subscription",
            paymentSuccessTo: "/megascans",
            paymentItem: topUp,
            paymentActionCreator: (0, _topups.buyTopup)({
              planId: planId,
              addOnId: topUp.id
            })
          })
        );
      }
    }
  }, {
    key: "renderPriceBox",
    value: function renderPriceBox() {
      var price = this.props.price;

      var topUp = this.getCurrentTopUp();
      // console.log(topUp,price)

      if (topUp) {
        return _react2.default.createElement(_CheckoutPriceBox2.default, {
          itemName: topUp.points + " Points",
          itemPrice: topUp.price,
          total: _ramda2.default.propOr(topUp.price, "price", price)
          // subTotalPrice={topUp.price}
          , taxPrice: _ramda2.default.propOr(0, "vatAmount", price),
          loadingPrice: price.loading,
          footNote: "* One time purchase"
        });
      }
    }
  }, {
    key: "renderStickyBar",
    value: function renderStickyBar() {
      var price = this.props.price;

      var topUp = this.getCurrentTopUp();

      if (topUp) {
        return _react2.default.createElement(_CheckoutStickyHeader2.default, {
          itemName: topUp.points + " Points",
          total: _ramda2.default.propOr(topUp.price, "price", price),
          subTotalPrice: topUp.price,
          taxPrice: _ramda2.default.propOr(0, "vatAmount", price),
          loadingPrice: price.loading,
          footNote: "* One time purchase"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$currentPayment = this.props.currentPayment,
          done = _props$currentPayment.done,
          paymentItem = _props$currentPayment.paymentItem;

      var topUp = this.getCurrentTopUp();
      var subTitle = done && paymentItem ? "Thank you for purchasing " + paymentItem.points + " Points!" : "Please double check everything before you proceed.";

      return topUp ? _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_components.SiteHeaderGap, null),
        _react2.default.createElement(_CheckoutLayout2.default, {
          headerIconSrc: "/quixel_2080_logo.png",
          title: done ? "Thank you!" : "Checkout",
          subTitle: subTitle,
          form: this.renderPaymentWizard(),
          sidebarOnDesktop: this.renderPriceBox(),
          stickyBarOnMobile: this.renderStickyBar()
        })
      ) : _react2.default.createElement("div", null);
    }
  }]);
  return BuyPoints;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = BuyPoints;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/BuyPoints/BuyPoints.jsx
// module id = 2941
// module chunks = 0